// Calcolo del corrispettivo minimo di attestazione SOA
// (D.P.R. 207/2010, allegato C, parte I). Funzioni pure: nessuna dipendenza dalla UI.

// Coefficiente ISTAT del costo della vita. Aggiornare qui quando cambia.
export const COEFF_R = 1.55;

// Importi fissi delle variazioni (5% e 10% del minimo di una nuova attestazione)
export const IMPORTO_VARIAZIONE_5 = 335.08;
export const IMPORTO_VARIAZIONE_10 = 670.16;

export const CLASSI = [
  { value: 'I',        label: 'Classe I',        importo: 258000 },
  { value: 'II',       label: 'Classe II',       importo: 516000 },
  { value: 'III',      label: 'Classe III',      importo: 1033000 },
  { value: 'III bis',  label: 'Classe III-bis',  importo: 1500000 },
  { value: 'IV',       label: 'Classe IV',       importo: 2582000 },
  { value: 'IV bis',   label: 'Classe IV-bis',   importo: 3500000 },
  { value: 'V',        label: 'Classe V',        importo: 5165000 },
  { value: 'VI',       label: 'Classe VI',       importo: 10329000 },
  { value: 'VII',      label: 'Classe VII',      importo: 15494000 },
  { value: 'VIII',     label: 'Classe VIII',     importo: 20658000 },
];

export const IMPORTO_CLASSE_II = 516000;

// Elenco delle categorie come nel calcolatore di riferimento (non influisce sull'importo)
export const CATEGORIE = [
  "OG 1 Edifici civili e industriali",
  "OG 2 Restauro e manutenzione dei beni immobili sottoposti a tut.",
  "OG 3 Strade, autostrade, ponti, viadotti, ferrovie, metropolitane",
  "OG 4 Opere d\\'arte nel sottosuolo",
  "OG 5 Dighe",
  "OG 6 Acquedotti, gasdotti , oleodotti, opere di irrig.e di evac.",
  "OG 7 Opere marittime e lavori di dragaggio",
  "OG 8 Opere fluviali, di difesa, di sistemaz. idraulica e di bonifica",
  "OG 9 Impianti per la produzione di energia elettrica",
  "OG 10 Impianti per la trasf./distribuzione alta/media tens.",
  "OG 11 Impianti tecnologici",
  "OG 12 Opere ed impianti di bonifica e protezione ambientale",
  "OG 13 Opere di ingegneria naturalistica",
  "OS 1 Lavori in terra",
  "OS 2 Superf. decorate e beni mobili di interesse storico e artistico",
  "OS 3 Impianti idrico-sanitario, cucine, lavanderie",
  "OS 4 Impianti elettromeccanici trasportatori",
  "OS 5 Impianti pneumatici e antintrusione",
  "OS 6 Finiture di op. generali in mat. lignei, plastici, metal.e vetrosi",
  "OS 7 Finiture di opere generali di natura edile",
  "OS 8 Finiture di opere generali di natura tecnica",
  "OS 9 Impianti per la segnal. luminosa e la sicurezza del traffico",
  "OS 10 Segnaletica stradale non luminosa",
  "OS 11 Apparecchiature strutturali speciali",
  "OS 12 Barriere e protezioni stradali",
  "OS 13 Strutture prefabbricate in cemento armato",
  "OS 14 Impianti di smaltimento e recupero rifiuti",
  "OS 15 Pulizia di acque marine, lacustri, fluviali",
  "OS 16 Impianti per centrali produzione energia elettrica",
  "OS 17 Linee telefoniche ed impianti di telefonia",
  "OS 18 Componenti strutturali in acciaio o metallo",
  "OS 19 Impianti di reti di telecomunicazione e di trasmissioni e tratt.",
  "OS 20 Rilevamenti topografici",
  "OS 21 Opere strutturali speciali",
  "OS 22 Impianti di potabilizzazione e depurazione",
  "OS 23 Demolizione di opere",
  "OS 24 Verde e arredo urbano",
  "OS 25 Scavi archeologici",
  "OS 26 Pavimentazioni e sovrastrutture speciali",
  "OS 27 Impianti per la trazione elettrica",
  "OS 28 Impianti termici e di condizionamento",
  "OS 29 Armamento ferroviario",
  "OS 30 Impianti interni elettrici, telefonici, radiotelefonici e televisivi",
  "OS 31 Impianti per la mobilità sospesa",
  "OS 32 Strutture in legno",
  "OS 33 Coperture speciali",
  "OS 34 Sistemi antirumore per infrastrutture di mobilità",
];

export const importoClasse = valore => CLASSI.find(c => c.value === valore)?.importo ?? null;

// Arrotondamento identico a quello del calcolatore di riferimento: si tagliano i
// centesimi e si aggiunge 1 centesimo se la terza cifra decimale supera 5
// (per il valore scontato: se è almeno 5). Calcolo in centesimi interi.
export function arrotonda(valore, scontato = false) {
  const [intero, frazione = ''] = String(valore).split('.');
  const centesimi = parseInt(intero, 10) * 100 + parseInt((frazione + '00').slice(0, 2), 10);
  const terza = parseInt((frazione + '000')[2], 10);
  const sale = scontato ? terza >= 5 : terza > 5;
  return (centesimi + (sale ? 1 : 0)) / 100;
}

// Corrispettivo base: C = somma degli importi delle classifiche, N = numero di categorie
export function corrispettivoBase(somma, nCategorie) {
  return (somma / 12500 + (2 * nCategorie + 8) * 413.16) * 1.0413 * COEFF_R;
}

// Lo sconto del 20% è previsto solo se tutte le classifiche sono al massimo la II
export const scontoAmmesso = importi => importi.length > 0 && importi.every(i => i <= IMPORTO_CLASSE_II);

function esito(valore, ammesso, fattore = 1) {
  return {
    totale: arrotonda(valore * fattore),
    scontato: ammesso ? arrotonda(valore * 0.8 * fattore, true) : null,
  };
}

// righe: array di valori di classe (es. ['I', 'II'])
export function calcolaRinnovo(classi) {
  const importi = classi.map(importoClasse);
  const base = corrispettivoBase(importi.reduce((s, i) => s + i, 0), importi.length);
  return { ...esito(base, scontoAmmesso(importi)), formula: { C: importi.reduce((s, i) => s + i, 0), N: importi.length } };
}

export function calcolaRevisione(classi) {
  const importi = classi.map(importoClasse);
  const base = corrispettivoBase(importi.reduce((s, i) => s + i, 0), importi.length);
  return { ...esito(base, scontoAmmesso(importi), 0.6), formula: { C: importi.reduce((s, i) => s + i, 0), N: importi.length } };
}

// Aumento di classifica: si paga sulla differenza tra classe nuova e vecchia, per una categoria, diviso 3
export function calcolaAumento(classeVecchia, classeNuova) {
  const vecchia = importoClasse(classeVecchia);
  const nuova = importoClasse(classeNuova);
  const differenza = nuova - vecchia;
  const base = corrispettivoBase(differenza, 1);
  const r = esito(base, scontoAmmesso([nuova]), 1 / 3);
  return { ...r, formula: { C: differenza, N: 1 } };
}

// Variazioni a corrispettivo fisso (voci 5.1.1, 5.1.2, 5.1.3, 5.3.1, 5.3.2).
// Segue la logica del calcolatore di riferimento: le voci 5.1.x combinate si pagano a metà.
export function calcolaVariazioni({ denominazione, sede, soggetti, nSoggetti, qualita }) {
  const imp1 = IMPORTO_VARIAZIONE_5;
  const imp2 = IMPORTO_VARIAZIONE_10;
  const a = soggetti ? 1 : 0;
  const i = soggetti ? Math.max(1, parseInt(nSoggetti, 10) || 1) : 0;
  const t = (denominazione ? 1 : 0) + (sede ? 1 : 0) + (soggetti ? 2 : 0);

  let e = 0;
  if (t === 1) e = imp1;
  if (t === 2 && a && i === 1) e = imp2;
  if (t === 2 && a && i >= 2) e = (imp2 * i) / 2;
  if (t >= 2 && !a) e = (imp1 * t) / 2;
  if (t >= 3 && a) e = (imp2 * i + imp1 * (t - 2)) / 2;
  if (qualita) e += imp1;

  const totale = aCentesimi(e);
  const alternativo = aCentesimi(variazioniImportoPiuAltoIntero({ denominazione, sede, soggetti, nSoggetti: i, qualita }));
  // Le due modalità coincidono quando c'è una sola voce: in quel caso non si propone l'alternativa
  return { totale, scontato: null, alternativo: alternativo !== totale ? alternativo : null };
}

const aCentesimi = v => Math.round((v + Number.EPSILON) * 100) / 100;

// Modalità alternativa: l'importo più alto si paga per intero, tutti gli altri al 50%.
// Per i soggetti (5.1.3): 1 soggetto = importo del 10%; da 2 in poi 10% × n soggetti / 2.
function variazioniImportoPiuAltoIntero({ denominazione, sede, soggetti, nSoggetti, qualita }) {
  const importi = [];
  if (denominazione) importi.push(IMPORTO_VARIAZIONE_5);
  if (sede) importi.push(IMPORTO_VARIAZIONE_5);
  if (soggetti) importi.push(nSoggetti >= 2 ? (IMPORTO_VARIAZIONE_10 * nSoggetti) / 2 : IMPORTO_VARIAZIONE_10);
  if (qualita) importi.push(IMPORTO_VARIAZIONE_5);
  importi.sort((x, y) => y - x);
  return importi.reduce((tot, imp, k) => tot + (k === 0 ? imp : imp / 2), 0);
}
